module.exports = __webpack_public_path__ + "media/vocal_duo.b1e7ad15.wav";